export const ScoreType_EvidenceBased = 'evidence-based';
export const ScoreType_ClinicalFunction = 'clinical-function';
export const ScoreTypes = [ScoreType_EvidenceBased, ScoreType_ClinicalFunction];
//# sourceMappingURL=types.js.map